var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useImperativeHandle, useRef, } from 'react';
import { CFContainer } from '../../components';
import { useCFTestID } from '../../hooks';
import { CFAccordion } from './Accordion';
export const CFAccordionGroupCore = (_a, ref) => {
    var { allowMultiple = false, items, onChange } = _a, rest = __rest(_a, ["allowMultiple", "items", "onChange"]);
    const { commonAttrs } = useCFTestID('cf-accordion-group', rest);
    const accordionRefs = useRef([]);
    const findAccordionById = (id) => accordionRefs.current.find(({ current }) => id === (current === null || current === void 0 ? void 0 : current.id));
    const togglePanels = (panelId, active) => {
        accordionRefs.current.forEach((ref) => {
            var _a, _b, _c;
            if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.id))
                return null;
            if (!allowMultiple &&
                ((_b = ref.current) === null || _b === void 0 ? void 0 : _b.id) !== panelId &&
                ((_c = ref.current) === null || _c === void 0 ? void 0 : _c.active)) {
                ref.current.setActive(false);
            }
        });
        if (onChange)
            onChange(panelId, active);
    };
    useImperativeHandle(ref, () => {
        return {
            getItems: () => {
                return accordionRefs.current.map(({ current }) => {
                    if (!current)
                        return null;
                    const { active, id } = current;
                    return { active, id };
                });
            },
            setActive: (panelId, active) => {
                var _a;
                const match = findAccordionById(panelId);
                if (match) {
                    (_a = match.current) === null || _a === void 0 ? void 0 : _a.setActive(active);
                    togglePanels(panelId, active);
                    return true;
                }
                return null;
            },
            toggle: (panelId) => {
                var _a;
                const match = findAccordionById(panelId);
                if (match) {
                    const toggledValue = !!((_a = match.current) === null || _a === void 0 ? void 0 : _a.toggle());
                    togglePanels(panelId, toggledValue);
                    return toggledValue;
                }
                return null;
            },
        };
    });
    return (React.createElement(CFContainer, Object.assign({ gap: 'c' }, commonAttrs), items.map((_a, i) => {
        var { label, id, children } = _a, rest = __rest(_a, ["label", "id", "children"]);
        if (i === 0)
            accordionRefs.current = [];
        const accordionRef = useRef(null);
        accordionRefs.current.push(accordionRef);
        return (React.createElement(CFAccordion, Object.assign({ id: id, key: id, label: label, onClickTrigger: togglePanels, ref: accordionRef }, rest), children));
    })));
};
export const CFAccordionGroup = forwardRef(CFAccordionGroupCore);
